<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" [class.active]="active">
  <g clip-path="url(#clip0_25533_18169)">
    <path
      d="M5 1V3"
      [attr.stroke]="active ? 'white' : 'black'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M14 1V3"
      [attr.stroke]="active ? 'white' : 'black'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M17.414 18.414C17.039 18.7891 16.5304 18.9999 16 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H9H16C16.5304 3 17.0391 3.21071 17.4142 3.58579C17.7893 3.96086 18 4.46957 18 5V17C17.9999 17.5304 17.7891 18.039 17.414 18.414Z"
      [attr.stroke]="active ? 'white' : 'black'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M13.832 7L8.58203 14L5.08203 11.376"
      [attr.stroke]="active ? 'white' : 'black'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_25533_18169">
      <rect width="19" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
